/*=========================================================================================
  File Name: moduleVehicleState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	vehicles: [],
	assignedVehicles: [],
	checkedVehicles: [],
	currentVehicle: {},
	depotInfoInit: null,
	depotInfoEnd: null,
	resourceListDatarutas: [],
	checkedResourceDatarutas: [],
	uploadFileList: [],
	checkedUploadFiles: [],
};
